import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithInterceptor } from 'src/utils/baseQuery';

type User = {
  user: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    type: string | undefined;
    designation: string;
    phone: number;
  };
  organization: {
    name: string;
    // address: string;
    address: {
      street?: string;
      city?: string;
      country?: string;
    };
  };
};

type SendOTPPayloadType = {
  email: string;
}

type VerifyOTPPayloadType = {
  email: string;
  code: string;
}

export const AuthApi = createApi({
  reducerPath: 'AuthApi',
  baseQuery: baseQueryWithInterceptor,
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    // loginUser: builder.mutation<LoginResponse, LoginUser>({
    //   query: (data) => ({
    //     headers: {
    //       'Content-type': 'application/json',
    //     },
    //     url: 'auth/login',
    //     method: 'POST',
    //     body: data,
    //   }),
    // }),
    // registerUser: builder.mutation<User, Partial<User>>({
    //   query: (data) => ({
    //     headers: {
    //       'Content-type': 'application/json',
    //     },
    //     url: 'auth/register',
    //     method: 'POST',
    //     body: data,
    //   }),
    // }),
    sendOTP: builder.mutation<User, SendOTPPayloadType>({
      query: (data) => ({
        headers: {
          'Content-type': 'application/json',
        },
        url: 'user/login',
        method: 'POST',
        body: data,
      }),
    }),
    verifyOTP: builder.mutation<string, VerifyOTPPayloadType>({
      query: (data) => ({
        headers: {
          'Content-type': 'application/json',
        },
        url: 'user/verify',
        method: 'POST',
        body: data,
      }),
      transformResponse: (response:string, meta, arg) => JSON.parse(response),
    }),
    logout: builder.mutation<User, Partial<User>>({
      query: (data) => ({
        headers: {
          'Content-type': 'application/json',
        },
        url: 'user/logout',
        method: 'POST',
        body: data,
      }),
    }),
    register: builder.mutation<any, FormData>({
      query: (formData) => ({
        url: 'user/register',
        method: 'POST',
        body: formData,
      }),
    }),
  }),
});

export const { 
  useSendOTPMutation,
  useVerifyOTPMutation,
  useLogoutMutation,
  useRegisterMutation 
} = AuthApi;
